import { defaultInstallmentEnabled } from "../../../constants/paymentConstants";

export const CARD_TYPES = [
    "WORLD", "AXESS", "MAXIMUM", "CARDFINANS",
    "PARAF", "ADVANTAGE", "COMBO", "BONUS", "SAGLAMKART", "STANDART"
];
export const MAX_INSTALLMENTS = 12;

/**
 * Hızlı işlem çipleri. Çip bir ÜST SINIR seçer: 1'den seçilene kadar tüm
 * taksitler açılır, üstü kapanır ("6 Taksit" = tek çekim + 2 + 3 + 4 + 5 + 6).
 * Aradan taksit çıkarmak (ör. 2'yi kapatmak) kutucuklardan yapılır.
 */
export const QUICK_INSTALLMENTS = [1, 2, 3, 6];

/** 1 → "Tek Çekim", diğerleri → "3 Taksit". Ekranın her yerinde aynı sözlük. */
export const installmentLabel = (count) =>
    Number(count) === 1 ? "Tek Çekim" : `${count} Taksit`;

/**
 * Boş ızgara: her marka için 1..12 arası tüm hücreler.
 *
 * Oluşturma modunda ızgara eskiden `{}` ile başlıyordu ve yalnız aktif POS'tan
 * dönen markalar doluyordu. Ekranda 12 hücre görünse de state'te karşılıkları
 * olmadığı için "Tümünü Kaldır" o markalarda hiçbir şey yapmıyor, kaydederken de
 * hücreler gönderilmediği için backend hepsini "açık, %0" varsayıyordu
 * (AccountGroupServiceImpl eksik kombinasyonları böyle dolduruyor). Izgarayı
 * baştan tam kurmak iki sorunu da kaynağında kesiyor.
 */
export const buildEmptyRates = () => {
    const rates = {};
    CARD_TYPES.forEach((card) => {
        rates[card] = {};
        for (let i = 1; i <= MAX_INSTALLMENTS; i++) {
            rates[card][i] = { id: null, value: "", enabled: defaultInstallmentEnabled(card) };
        }
    });
    return rates;
};

export const convertBackendRatesToFrontend = (installmentRates = []) => {
    const rates = {};

    installmentRates.forEach((r) => {
        const brand = (r.brand ?? r.cardBrand ?? "").toUpperCase();
        if (!rates[brand]) rates[brand] = {};

        rates[brand][r.installmentCount] = {
            id: r.id ?? null,
            value: Number(r.commissionPercent ?? r.commissionRate ?? 0).toFixed(2),
            enabled: r.enabled != null ? r.enabled : defaultInstallmentEnabled(brand),
        };
    });

    CARD_TYPES.forEach((card) => {
        if (!rates[card]) rates[card] = {};
        for (let i = 1; i <= MAX_INSTALLMENTS; i++) {
            if (!rates[card][i]) {
                rates[card][i] = { id: null, value: "0.00", enabled: defaultInstallmentEnabled(card) };
            }
        }
    });

    return rates;
};

/**
 * Izgarayı backend listesine çevirir.
 *
 * Oranı boş bırakılan hücre ATLANMAZ, %0 olarak gönderilir. Eskiden atlanıyordu;
 * backend de gelmeyen kombinasyonu "açık, %0" diye ürettiği için kullanıcının
 * kapattığı taksit kaydedince sessizce geri açılıyordu. Komisyon zaten her iki
 * durumda da 0 oluyor — değişen tek şey `enabled` bilgisinin korunması.
 */
export const convertFrontendRatesToBackend = (ratesObj = {}) => {
    const list = [];
    Object.entries(ratesObj).forEach(([cardBrand, counts]) => {
        Object.entries(counts).forEach(([instCnt, cell]) => {
            const { id, value, enabled } = cell || {};
            const parsed = parseFloat(value);
            list.push({
                id,
                cardBrand,
                installmentCount: parseInt(instCnt, 10),
                commissionPercent: Number.isNaN(parsed) ? 0 : parsed,
                enabled: enabled !== false,
            });
        });
    });
    return list;
};
